import { Component, Input, OnInit } from "@angular/core";
import { Store } from "../../../services/store.service";
import { MyFormioComponent } from "../../my-formio/my-formio.component";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "form-builder-actions",
  templateUrl: "./form-builder-actions.component.html",
  styleUrls: ["./form-builder-actions.component.scss"],
})
export class FormBuilderActionsComponent {

  @Input() public serviceId?: string;
  @Input() public myFormio?: MyFormioComponent | null;
  @Input() public copyHandler?: () => void;
  @Input() public downloadHandler?: () => void;
  @Input() public historyHandler?: () => void;
  @Input() public formKey?: string;
  @Input() public minUserLevel: number = 3;
  @Input() public requireService: boolean = true;
  @Input() public optionsLabel: string = "Form options";
  @Input() public copyLabelKey: string = "Copy";
  @Input() public downloadLabelKey: string = "Copy form schema with relations";
  @Input() public historyLabelKey: string = "Form history";
  @Input() public showReusableBlocksLabelKey: string = "Show reusable blocks";
  @Input() public dropdownAlign: "left" | "right" = "left";
  @Input() public dropdownPlacement: string = "left-top";
  public debugMode: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private store: Store) { }

  public ngOnInit(): void {
    this.checkDebugMode();
  }

  public checkDebugMode() {
    this.store.debugMode$.subscribe((mode) => {
      this.debugMode = mode;
    });
  }

  public get hasErrors(): boolean {
    return this.myFormio?.debugErrors?.length > 0;
  }

  public get shouldDisplay(): boolean {
    if (!this.hasAvailableActions) {
      return false;
    }

    if (this.requireService && !this.serviceId) {
      return false;
    }

    const level = this.store?.state?.common?.userLevels?.pages?.SideNavLevel;
    if (typeof level !== "number") {
      return this.minUserLevel === 0;
    }
    return level >= this.minUserLevel;
  }

  public get hasAvailableActions(): boolean {
    return this.canCopy || this.canDownload || this.canOpenHistory || this.canShowReusableBlocks;
  }

  public get canShowReusableBlocks(): boolean {
    return !!this.formKey;
  }

  public get canCopy(): boolean {
    return typeof this.copyHandler === "function" || typeof this.myFormio?.copyComponent === "function";
  }

  public get canDownload(): boolean {
    return typeof this.downloadHandler === "function";
  }

  public get canOpenHistory(): boolean {
    return typeof this.historyHandler === "function";
  }

  public get dropdownMenuClasses(): string[] {
    if (this.dropdownAlign === "left") {
      return ["dropdown-menu", "dropdown-menu-left-outside"];
    }
    return ["dropdown-menu", "dropdown-menu-right", "dropdown-menu-right-outside"];
  }

  public handleCopy(): void {
    if (!this.canCopy) {
      return;
    }
    if (this.copyHandler) {
      this.copyHandler();
      return;
    }
    this.myFormio?.copyComponent();
  }

  public handleDownload(): void {
    if (!this.canDownload) {
      return;
    }
    this.downloadHandler?.();
  }

  public handleHistory(): void {
    if (!this.canOpenHistory) {
      return;
    }
    this.historyHandler?.();
  }

  public handleShowReusableBlocks(): void {
    if (!this.canShowReusableBlocks) {
      return;
    }
    // Access the globally stored WebformBuilder instance
    const builderInstance = (window as any).formioBuilderInstance;
    if (builderInstance && typeof builderInstance.openComponentsModal === 'function') {
      builderInstance.openComponentsModal();
    } else {
      console.error('FormIO Builder instance not found or openComponentsModal method not available');
    }
  }
}
